import { useContext } from "react";
import { UserContext } from "../../App";

export default function useDistrictNameByCityAndId(city,districtId,lang='ar') {

    const {confguration} = useContext(UserContext);

    if(lang === 'ar') {
        return confguration?.enums?.districts?.find(c => c?.id === city)?.districts?.find(d => d?.id === districtId)?.ar;
    } else {
        return confguration?.enums?.districts?.find(c => c?.id === city)?.districts?.find(d => d?.id === districtId)?.en;
    }
}